const default_model = () => (
  { is_alive : true, permissions : 'Owner' }
);


import codes from '@/codes';
// import { Api } from '@/service';
import { admin as manager } from '@/service/api/manager';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import reg from '@/reg';

// another vue
import logLoginList from '../../../Log/login/login.Admin.List.i18n'
import logActionList from '../../../Log/action/action.Admin.List.i18n'

export default {
  props: ['admin_id'],
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  components: {
    cSwitch,
    vSelect,
    logLoginList,
    logActionList
  },
  data : () => ({
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : default_model(),
      allowed: false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
  }),
  computed: {
    // profile() { return auth.profile; }
  },
  methods: {
    async get() {
      this.model = default_model()

      console.log('admin.detail.vue', 'load item', this.admin_id);
      if(!this.admin_id) { return this.$toastr.e('incorrect target partner') }

      try{
        this.add = false;
        this.lock = true

        // let rs = await Api.Manager_Call('admin', 'detail', { id : this.admin_id })
        let rs = await manager.detailAdmin({ id : this.admin_id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('admin_Detail.vue', 'created'); },
  destroyed() { console.log('admin_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('admin_Detail.vue', 'mounted');
    this.get();
  },
}